import Vue from 'vue';

const getDefaultBookingsState = () => ({
  feed: [
    {
      bookings: {},
    },
  ],
  orders: {},
  booking: {},
  allBookings: {},
});

export default {
  state: getDefaultBookingsState(),
  actions: {
    async GET_BOOKINGS(context, payload) {
      const request = {
        url: '/api/v4/people/bookings/current/feed',
      };
      const mutation = 'UPDATE_BOOKINGS';
      const options = {
        request,
        mutation,
      };

      await context.dispatch('MAKE_GET_REQUEST', options);
    },

    async GET_ALL_BOOKINGS(context, payload) {
      const request = {
        url: `/api/v4/people/bookings/all/${payload.offset}/${payload.limit}`,
      };
      const mutation = 'UPDATE_ALL_BOOKINGS';
      const options = {
        request,
        mutation,
      };

      return await context.dispatch('MAKE_LAZY_LOAD_GET_REQUEST', options);
    },

    async GET_BOOKING(context, payload) {
      const request = {
        url: `/api/v4/people/bookings/${payload.clientId}/${payload.bookingId}`,
      };

      const mutation = 'UPDATE_BOOKING';
      const options = {
        request,
        mutation,
      };

      await context.dispatch('MAKE_GET_REQUEST', options);
    },

    async GET_ORDER(context, payload) {
      const request = {
        url: `/api/v4/people/orders/${payload.clientId}/${payload.orderId}`,
      };
      const mutation = 'UPDATE_ORDERS';
      const options = {
        request,
        mutation,
      };
      await context.dispatch('MAKE_GET_REQUEST', options);
    },
  },

  mutations: {
    UPDATE_BOOKINGS(state, payload) {
      state.feed = payload;
    },

    UPDATE_ALL_BOOKINGS(state, payload) {
      payload.forEach((value, index, array) => {
        Vue.set(state.allBookings, value.bookingId, value);
      });
    },

    UPDATE_BOOKING(state, payload) {
      state.booking = payload;
    },

    UPDATE_ORDERS(state, payload) {
      Vue.set(state.orders, payload.orderId, payload);
    },

    RESET_BOOKINGS_STATE(state) {
      Object.assign(state, getDefaultBookingsState());
    },
  },

  getters: {
    feed(state) {
      return state.feed;
    },

    bookings(state) {
      return state.allBookings;
    },
    booking(state) {
      return state.booking;
    },
    orders(state) {
      return state.orders;
    },
  },
};
